import { Link } from 'components/router';
import Group from '../panel/group';

const SubtitlesFooter = () => {
  return (
    <div
      data-testid="subtitles-footer"
      className="mr-3 flex flex-row justify-between bg-white px-3 pl-6 md:w-full"
    >
      <Group className="border-gray-300 py-3 sm:border-t-thick">
        <div
          className="-ml-3 flex flex-row items-baseline py-2"
          data-testid="subtitles-footer-message"
        >
          <span>
            Don&apos;t see a language,&nbsp;
            <Link
              href="/participate/translate"
              className="bg-transparent text-blue-500 underline hover:text-blue-700"
              isZenithLink
            >
              become a translator
            </Link>
          </span>
        </div>
      </Group>
    </div>
  );
};

export default SubtitlesFooter;
